import React, { useState, Fragment } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Divider } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { sendTotpCode } from "../../redux/actions/loginactioncreators";
import { navigateToLogin } from "../../redux/helpers/navigators";
import OtpCodeEntry from "./MfaOtpCodeEntry";
import { MfaPageContainer } from "./MfaPageContainer.jsx";
import { ExpandMoreRounded } from "@material-ui/icons";

export default function MfaTotpCodeEntry() {
  const dispatch = useDispatch();
  const [totpCode, setTotpCode] = useState("");
  const [totpCodeValid, setTotpCodeValid] = useState(false);

  const {
      baseUrl,
      mfaTotpConfig
    } = useSelector(state => ({
      baseUrl: state.loginForm.baseUrl,
      mfaTotpConfig: state.loginForm.mfa.config.totp,
    }));
  const otpCodeLength = mfaTotpConfig?.codeLength ?? 6;

  const otpOnChange = (value) => {
    setTotpCode(value);
    setTotpCodeValid(value.length === otpCodeLength);
  };

  const isTotpCodeValid = (value) => {
    return value.length === otpCodeLength;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (totpCodeValid) {
      dispatch(sendTotpCode(totpCode));
    }
  };

  const handleClickBack = () => {
    navigateToLogin();
  };

  const InstructionalText = () => {
    return (
      <Fragment>
        <FormattedMessage
          tagName="div"
          id="totp.blurb"
          defaultMessage="Please use your Google Authenticator, or other Time-Based One-Time Password App to generate a code below."
          description="Instructions for using TOTP authenticator app"
        />
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreRounded />}>
            <FormattedMessage
              tagName="div"
              id="totp.helpMeLinkText"
              defaultMessage="Help me find my code"
              description="Text for expandable help section"
            />
          </AccordionSummary>
          <AccordionDetails>
            <Divider component="span" />
            <div className="flex items-center p-4">
              <FormattedMessage
                tagName="div"
                id="totp.helpMeBlurb"
                defaultMessage="You can find your time-based code generated in your authenticator app. It will change periodically."
                description="Help text explaining how to find TOTP codes"
              />
            </div>
            <img
              loading="lazy"
              src={`${baseUrl}/assets/both_authenticators_anim_optimized_700px.gif`}
              className="h-[320px] w-[150px]"
              alt=""
            />
          </AccordionDetails>
        </Accordion>
      </Fragment>
    )
  }

  return (
    <div id="totpCode">
      <MfaPageContainer
        onSubmit={handleSubmit}
        showErrors={true}
        requiredFields={[]}
        headerText={<FormattedMessage id="mfa.enterCode" defaultMessage="Enter code" description="A terse message, shown when an MFA code is required"/>}
        instructionalText={<InstructionalText />}
        submitButtonText={<FormattedMessage id="mfaSetup.continueButton" defaultMessage="Continue" description="Submit TOTP code" />}
        secondaryButtonText={<FormattedMessage id="mfaSetup.backButton" defaultMessage="Back" description="Return to login" />}
        secondaryButtonHandler={handleClickBack}
        onChange={otpOnChange}
        otpValidator={isTotpCodeValid}
      >
        <OtpCodeEntry id="otpCodeEntry" length={otpCodeLength} onChange={otpOnChange} />
      </MfaPageContainer>
    </div>
  );
}
